import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "coupon v-fade" }
const _hoisted_2 = { class: "coupon__content" }
const _hoisted_3 = { class: "coupon__text-box" }
const _hoisted_4 = {
  key: 0,
  class: "coupon__title"
}
const _hoisted_5 = { class: "coupon__value coupon__value--number" }
const _hoisted_6 = {
  key: 1,
  class: "coupon__title"
}
const _hoisted_7 = {
  key: 2,
  class: "coupon__title"
}
const _hoisted_8 = { class: "coupon__text" }

import { BillingView } from '@/models/billing'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingCoupon',
  props: {
    billing: {}
  },
  setup(__props: any) {

const props = __props

const isPercentageDiscount = computed(() => {
  return props.billing.billing_plans.discount.type_annual === 'percentage'
})

const isFixedDiscount = computed(() => {
  return props.billing.billing_plans.discount.type_annual === 'fixed_amount'
})

// The hardcoded case for the #15680 New User Messaging Journey: Monthly users upsell logic
// (marketing_source.url_slug = new-upgrade-to-annual, coupon: OFF_FLAT_16_42)
const isNewUpgradeToAnnualFixedDiscount = computed(() => {
  return (
    props.billing.billing_plans.discount.type_annual === 'fixed_amount' &&
    props.billing.billing_plans.discount.value_annual === 1642
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (isPercentageDiscount.value)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [
              _cache[0] || (_cache[0] = _createTextVNode(" You've unlocked ", -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(__props.billing.billing_plans.discount.value_annual) + "% ", 1),
              _cache[1] || (_cache[1] = _createTextVNode(" off your subscription! ", -1))
            ]))
          : (isFixedDiscount.value && !isNewUpgradeToAnnualFixedDiscount.value)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_6, " You've unlocked a discount on your subscription! "))
            : (isNewUpgradeToAnnualFixedDiscount.value)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" You've unlocked ", -1),
                  _createElementVNode("span", { class: "coupon__value" }, " 1 month free ", -1),
                  _createTextVNode(" on your subscription! ", -1)
                ]))]))
              : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_8, _toDisplayString(__props.billing.billing_plans.discount.prompt), 1)
      ])
    ])
  ]))
}
}

})